module.exports = __webpack_public_path__ + "img/facebook_ikona.63cc8612.svg";